import React from 'react';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Box from '@material-ui/core/Box';

import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { ContactDuplicateField, IContactDuplicateMatch, SportTermLookup } from '../../lib/types';
import { getContactDuplicateMessages } from './player-contact.messages';

interface IContactDuplicateWarningProps {
  matches: IContactDuplicateMatch[];
  // Passed down rather than read here, so the banner names the athlete the same
  // way the field labels above it do — both resolve off the form's one sport.
  termLookup: SportTermLookup;
}

// Advisory banner: the contact being entered overlaps one already on this
// athlete. Rendered by the shared field block, so every form shows it.
export const ContactDuplicateWarning: React.FC<IContactDuplicateWarningProps> = ({ matches, termLookup }) => {
  if (matches.length === 0) return null;

  const messages = getContactDuplicateMessages(termLookup);
  const messageByField = {
    [ContactDuplicateField.Email]: messages.duplicateEmail,
    [ContactDuplicateField.Phone]: messages.duplicatePhone,
    [ContactDuplicateField.Name]: messages.duplicateName,
  };

  return (
    <Box mt={1} mb={1}>
      <Alert severity="warning">
        <AlertTitle><IntlMsg {...messages.duplicateHeading} /></AlertTitle>
        {matches.map((match) => (
          <div key={match.field}>
            <IntlMsg
              {...messageByField[match.field]}
              values={{ contactName: match.contactName || <IntlMsg {...messages.duplicateUnnamedContact} /> }}
            />
          </div>
        ))}
        <Box mt={0.5}><IntlMsg {...messages.duplicateFooter} /></Box>
      </Alert>
    </Box>
  );
};
